<mat-card [class]="['card-product-download', 'bg-' + product.ProductCode.toLowerCase().replace('.', '') ]">
  <mat-card-title class="card-product-title">
    <img class="card-product-image" [src]="product.ImageUrl" [alt]="product.ProductCode" ><br />
  </mat-card-title>

  <mat-card-content class="card-product-content">
    <p class="release" *ngIf="product.Release">Release: {{ product.Release }}</p>
    <p class="date" *ngIf="product.Date">Data rilascio: {{ product.Date }}</p>
    <!--<mat-list>
      <a *ngFor="let link of product.CardLinks" mat-list-item class="card-product-link-container" (click)="navigate(link.Url, link.Params)">
        <div class="card-product-link" translate>{{ link.Text }}</div>
        <mat-icon>arrow_right_alt</mat-icon>
      </a>
    </mat-list>-->
  </mat-card-content>
  <mat-card-actions class="card-product-action">
    <button mat-fab color="primary" (click)="openFamily()">
      <mat-icon>
        arrow_forward
        </mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
